import { render, staticRenderFns } from "./UserQa.vue?vue&type=template&id=118bd8fc&"
import script from "./UserQa.vue?vue&type=script&lang=js&"
export * from "./UserQa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports